
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "028b93b1596d8d433d085bfd16567a9697b65e6b",
  "nuxt": {
    "buildId": "0c3d2bc7-cd5d-49b8-8835-449c15743d8d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
